import { CoordinatePair } from "../../../utils/is-coordinate-pair";
import { FC, FormEventHandler, useEffect, useState } from "react";

interface FormSignature {
  annotationTypes: string[];
  description: string;
  maxX: number;
  maxY: number;
  minX: number;
  minY: number;
  onSubmit: (selection: CoordinatePair) => void;
  selection: CoordinatePair | null;
  setDescription: (description: string) => void;
  setWeight: (weight: number) => void;
  weight: number;
}

export const Form: FC<FormSignature> = ({
  annotationTypes,
  description,
  maxX,
  maxY,
  minX,
  minY,
  onSubmit,
  selection,
  setDescription,
  setWeight,
  weight,
}) => {
  const [endX, setEndX] = useState<number>();
  const [endY, setEndY] = useState<number>();
  const [startX, setStartX] = useState<number>();
  const [startY, setStartY] = useState<number>();

  useEffect(() => {
    if (!selection) {
      setEndX(undefined);
      setEndY(undefined);
      setStartX(undefined);
      setStartY(undefined);
      return;
    }

    setEndX(selection[1][0]);
    setEndY(selection[1][1]);
    setStartX(selection[0][0]);
    setStartY(selection[0][1]);
  }, [selection]);

  const onFormSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    if (startX && startY && endX && endY) {
      onSubmit([
        [startX, startY],
        [endX, endY],
      ]);

      setEndX(undefined);
      setEndY(undefined);
      setStartX(undefined);
      setStartY(undefined);
    }
  };

  return (
    <form className="srt" onSubmit={onFormSubmit}>
      <label>
        <span>New Annotation Start X</span>
        <input
          defaultValue={startX}
          max={maxX}
          min={minX}
          onChange={(e) => {
            setStartX(parseInt(e.target.value, 10));
          }}
          required={true}
          type="number"
        ></input>
      </label>
      <label>
        <span>New Annotation Start Y</span>
        <input
          defaultValue={startY}
          max={maxY}
          min={minY}
          onChange={(e) => {
            setStartY(parseInt(e.target.value, 10));
          }}
          required={true}
          type="number"
        ></input>
      </label>
      <label>
        <span>New Annotation End X</span>
        <input
          defaultValue={endX}
          max={maxX}
          min={minX}
          onChange={(e) => {
            setEndX(parseInt(e.target.value, 10));
          }}
          required={true}
          type="number"
        ></input>
      </label>
      <label>
        <span>New Annotation End Y</span>
        <input
          defaultValue={endY}
          max={maxY}
          min={minY}
          onChange={(e) => {
            setEndY(parseInt(e.target.value, 10));
          }}
          required={true}
          type="number"
        ></input>
      </label>
      <label>
        <span>New Annotation Description</span>
        <select
          onChange={(e) => {
            setDescription(e.target.selectedOptions[0].value);
          }}
          required={true}
          value={description}
        >
          {annotationTypes.map((a) => (
            <option key={a} value={a}>
              {a}
            </option>
          ))}
        </select>
      </label>
      <label>
        <span>New Annotation Weight</span>
        <input
          max={5}
          min={1}
          onChange={(e) => {
            setWeight(parseInt(e.target.value, 10));
          }}
          step={1}
          type="range"
          value={weight}
        ></input>
      </label>
      <button type="submit">Add New Annotation</button>
    </form>
  );
};
